import { render } from "./SignUpCollectivite.vue?vue&type=template&id=409afec4&scoped=true&ts=true"
import script from "./SignUpCollectivite.vue?vue&type=script&lang=ts"
export * from "./SignUpCollectivite.vue?vue&type=script&lang=ts"

import "./SignUpCollectivite.vue?vue&type=style&index=0&id=409afec4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409afec4"]])

export default __exports__